module.exports = __webpack_public_path__ + "media/staff/jose-contreras-jr-live-streaming-5d8c1e05.jpg";